import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import styled from '@emotion/styled';

export const TitleText = styled(Text)`
  color: ${nafColor.signature.white};
  margin: 0;

  &:not(:first-child) {
    margin-top: ${spacing.space24};
  }

  &:not(:last-child) {
    margin-bottom: ${spacing.space16};
  }

  :last-child {
    margin-top: 0;
  }

  @media (max-width: ${breakpoints.m}) {
    padding: 0 24px;
    text-align: center;
  }
`;

export const HeroWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin: 0 auto ${spacing.space160} auto;
  color: ${nafColor.signature.white};

  h3,
  h6,
  ${TitleText} {
    text-shadow: 0 2px ${spacing.space12} rgb(0 0 0 / 24%);
  }
`;

export const ImageWrapper = styled.div`
  padding-top: ${spacing.space160};
`;
